import { Icon as IconUI } from "@evergis/ui";
import styled from "styled-components";
import { Description as DescriptionLayer } from "../Layer/styled";

export const BlackIcon = styled(IconUI)`
  color: black;
`;

export const Description = styled(DescriptionLayer)`
  && {
    margin: 0.2rem 0 0;
  }
`;

export const TooltipLabel = styled.div`
  font-size: 10px;
  color: white;
`;

export const TooltipContent = styled(TooltipLabel)`
  opacity: 0.54;
  margin-top: 2px;
`;

export const TableAttributeActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
